import { useTranslation } from "react-i18next";

export function ScheduledJobsEmptyState() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-2 px-6 py-12 text-center">
      <p className="text-lg font-semibold leading-snug">
        {t("admin.scheduledJobs.empty.title", "No scheduled jobs found")}
      </p>
      <p className="text-xs text-muted-foreground">
        {t(
          "admin.scheduledJobs.empty.description",
          "Cloud Scheduler is not reporting any jobs for this project.",
        )}
      </p>
    </div>
  );
}
